type ParticipantChipsProps = {
  items: ReadonlyArray<{ id: string; label: string }>;
  onRemove: (id: string) => void;
  ariaLabel: string;
};

export function ParticipantChips({ items, onRemove, ariaLabel }: ParticipantChipsProps) {
  if (items.length === 0) {
    return null;
  }
  return (
    <ul className="chip-list" aria-label={ariaLabel}>
      {items.map((item) => (
        <li key={item.id} className="chip">
          <span className="chip__label">{item.label}</span>
          <button
            type="button"
            className="chip__remove"
            onClick={() => onRemove(item.id)}
            aria-label={`Убрать ${item.label}`}
          >
            ×
          </button>
        </li>
      ))}
    </ul>
  );
}
